import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DemoPageComponent } from "./demo-page/demo-page.component";
import { MaterialModule } from "../shared/material.module";
import { ProjectModule } from "../projects/project.module";
import { FormsModule } from "@angular/forms";
import { DemoPageHistory } from "./demo-page/demo-page-history.service";

@NgModule({
  imports: [CommonModule, ProjectModule, MaterialModule, FormsModule],
  declarations: [DemoPageComponent],
  exports: [DemoPageComponent],
  providers: [DemoPageHistory],
})
export class DemoModule {}



// WEBPACK FOOTER //
// ./src/app/demo/demo.module.ts